export const onOpenCasino = () => {
  const casinoSection = document.querySelector('#casino-section');
  if (casinoSection) {
    casinoSection.scrollIntoView({ behavior: 'smooth' });
  }
  window.$("body").removeClass("mr_menu_active");
};

export const onOpenSlotGame = () => {
  const slotGameSection = document.querySelector("#slotgame-section");
  if (slotGameSection) {
    slotGameSection.scrollIntoView({ behavior: "smooth" });
  }
  window.$("body").removeClass("mr_menu_active");
};

export const onOpenSports = (store) => {
  store.dispatch("getGameProcess", {});
  window.$("body").removeClass("mr_menu_active");
};

export const onOpenCashIn = (store) => {
  store.dispatch("showHomePopup", { open: true, tab: "recharege" });
  window.$("body").removeClass("mr_menu_active");
};

export const onOpenCashOut = (store) => {
  store.dispatch("showHomePopup", { open: true, tab: "exchange" });
  window.$("body").removeClass("mr_menu_active");
};
